module.exports = __webpack_public_path__ + "img/home_btn_collection@2x.26f8fd78.png";